import type { Brand } from "@borealis/layout-express";

export const isFinn = (brand: Brand) => {
  return brand.toLowerCase() === "finn";
};

const SCANDINAVIAN_MILE_BRANDS = ["finn", "blocket"];

/** Whether the brand quotes running costs per Scandinavian mil (FINN, Blocket) rather than per km (DBA). */
export const usesScandinavianMiles = (brand: Brand) => {
  return SCANDINAVIAN_MILE_BRANDS.includes(brand.toLowerCase());
};
